/**
 * Money icon — drop-in replacement for the old NexaCoin SVG.
 * Renders a circular coin with the active currency symbol in the centre.
 * Defaults to ₹ (INR). Pass `symbol="€"` to override for trip groups.
 *
 * Same className/size APIs as the lucide-react icon set so existing call
 * sites work unchanged.
 */
export default function NXCIcon({
  size = 16,
  className = '',
  strokeWidth = 1.6,
  symbol = '₹',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide ${className}`}
      aria-label="Currency"
      role="img"
      {...rest}
    >
      <circle cx="12" cy="12" r="10" />
      <text
        x="12"
        y="15.4"
        textAnchor="middle"
        fontSize="11"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontWeight="800"
        letterSpacing="-0.2"
        fill="currentColor"
        stroke="none"
      >
        {symbol}
      </text>
    </svg>
  );
}
